import React, { useState } from "react";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import AttributesContent from "./../cards/attributes";
import AttributeValuesContent from "../cards/attribute-values";

const drawerWidth = 240;

export default function AttributesV2({ token, setToken }) {
    const [attributeList, setAttributeList] = useState(null);
    const [selectedAttributeId, setSelectedAttributeId] = useState(null);

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                width: { sm: `calc(100% - ${drawerWidth}px)` },
                height: '100vh',
                overflow: 'auto',
                backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[900]
            }}
        >
            <Container
                maxWidth="lg"
                sx={{ display: 'flex' }}
                className="content-root"
            >
                <Toolbar />
                <Grid container spacing={3} className="flex-section"
                    sx={{
                        flexWrap: 'nowrap',
                    }}
                >
                    <Grid item xs={12} md={6} lg={4} className={"flex-col-scroll"}  >
                        <Paper sx={{
                            my: 4,
                            p: 2,
                            minHeight: 240,
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <AttributesContent token={token} setToken={setToken} attributeList={attributeList} setAttributeList={setAttributeList} selectedAttributeId={selectedAttributeId} setSelectedAttributeId={setSelectedAttributeId} />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} lg={8} className={"flex-col-scroll"}  >
                        <Paper
                            sx={{
                                my:4,
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <AttributeValuesContent token={token} setToken={setToken} attributeList={attributeList} setAttributeList={setAttributeList} selectedAttributeId={selectedAttributeId} />
                        </Paper>
                    </Grid>
                </Grid>
                {/* <Copyright sx={{ pt: 4 }} /> */}
            </Container>
        </Box>
    )
}